import { ChatInput } from '@terminal/components/chat';
import { TrackingMetadata } from '@terminal/services/tracking/posthog/constants';
import { useChatNavigation } from '@terminal/views/alfred/use-chat-navigation/useChatNavigation';
import clsx from 'clsx';
import { ReactNode, useEffect } from 'react';

import styles from './AlfredFooter.module.scss';
import { CollapsibleAlfredInput } from './CollapsibleAlfredInput';

export interface AlfredFooterProps {
  renderChatInput?: (override?: { cta?: ReactNode }) => ReactNode;
  selectedBadges?: ReactNode[];
  ctaLabel?: string;
  onCtaClick?: () => void;
  isCtaLoading?: boolean;
  shouldHide?: boolean;
  trackingMetadata?: TrackingMetadata;
  fixed?: boolean;
  autoFocus?: boolean;
}

export const AlfredFooter = ({
  shouldHide = false,
  trackingMetadata,
  fixed = false,
  autoFocus = false,
}: AlfredFooterProps) => {
  const { mode, setMode, resetPreviousMode } = useChatNavigation();

  useEffect(() => {
    if (mode !== 'research') {
      setMode('research');
    }

    resetPreviousMode();
  }, []);

  return (
    <footer
      className={clsx(styles.alfredFooterRoot, {
        [styles.hidden]: shouldHide,
        [styles.fixed]: fixed,
        [styles.sticky]: !fixed,
      })}
    >
      <div className={styles.inputRegion}>
        <CollapsibleAlfredInput initiallyFocused={autoFocus && !shouldHide}>
          <ChatInput
            config={{
              autoFocus: autoFocus && !shouldHide,
              alfredEverywhere: true,
              allowedModes: ['research'],
            }}
            trackingMetadata={trackingMetadata}
          />
        </CollapsibleAlfredInput>
      </div>
    </footer>
  );
};
